import React from 'react'
import cn from 'classnames'

import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'

const FormFieldGrid = props => (
    <Grid container alignItems={props.alignItems || "center"}
        className={cn('form-field', props.className)} style={{ ...props.style }}
    >
        <Grid item xs={3}>
            <Typography className="text-grey">{props.title}</Typography>
        </Grid>
        <Grid item xs={9}>
            {props.children}
        </Grid>
    </Grid>
)

export default FormFieldGrid;